<template>
  <v-container id="appointments-table" fluid>
    <v-card outlined>
      <v-data-table
        :headers="headers"
        :items="appointments"
        :options.sync="options"
        :server-items-length="totalAppointments"
        :footer-props="footerProps"
        :loading="loadingData"
        :loading-text="$t('appointment.loadingText')"
        :no-data-text="$t('appointment.noAppointments')"
        mobile-breakpoint="481"
        item-key="id"
        style="cursor: pointer"
        :header-props="headerProps"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-row v-if="!isMobile">
              <v-col align-self="center" class="px-1">
                <o-select-locations
                  v-if="isAdmin"
                  v-model="store"
                  :multiple="false"
                  :placeholder="$t('appointment.selectStore').toString()"
                  :outlined="true"
                  :clearable="true"
                  @input="list"
                />
              </v-col>
            </v-row>
            <v-spacer></v-spacer>
            <v-btn color="primary" outlined @click="reloadList()">
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </v-toolbar>
          <v-row v-if="isMobile" color="white" flat>
            <v-col cols="12">
              <o-select-locations
                class="mr-1 ml-1"
                v-if="isAdmin"
                v-model="store"
                :multiple="false"
                :placeholder="$t('appointment.selectStore').toString()"
                :outlined="true"
                :clearable="true"
                @input="list"
              />
            </v-col>
          </v-row>
        </template>

        <template v-slot:item.service.service_name="{ item }">
          <template v-if="typeof item.service.service_name === 'object'">
            {{
              item.service.service_name[$root.$i18n.locale] ||
              item.service.service_name[Object.keys(item.service.service_name)[0]]
            }}
          </template>
          <template v-else>
            {{ item.service.service_name }}
          </template>
        </template>
        <template v-slot:item.date_begin="{ item }">
          {{ formatDate(item.date_begin) }}
        </template>
        <template v-slot:item.created_at="{ item }">
          {{ formatDate(item.created_at) }}
        </template>
        <template v-slot:item.current_status="{ item }">
          {{ getStatusTranslation(item.current_status) }}
        </template>

        <template v-slot:item.action="{ item }">
          <v-btn
            :class="[$vuetify.breakpoint.width >= 481 ? '' : 'pr-0']"
            text
            color="primary"
            @click="executeAction(item._id)"
          >
            {{ $t('order.viewDetails') }}
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
  import { EventBus } from '../../event-bus'
  import moment from 'moment'
  import { mapState } from 'vuex'

  export default {
    name: 'InStoreAppointmentsTable',
    data() {
      return {
        headers: [
          {
            text: this.$t('appointment.appointmentType'),
            value: 'service.service_name',
            width: '200',
          },
          {
            text: this.$t('appointment.lastname'),
            value: 'customer.last_name',
          },
          {
            text: this.$t('appointment.firstname'),
            value: 'customer.first_name',
          },
          {
            text: this.$t('appointment.creationDate'),
            value: 'created_at',
          },
          {
            text: this.$t('appointment.date'),
            value: 'date_begin',
          },
          {
            text: this.$t('appointment.store'),
            value: 'location_id',
          },
          // {
          //     text:  "Vendeur",
          //     value: "seller_id"
          // },
          {
            text: this.$t('appointment.status'),
            value: 'current_status',
          },
          {
            value: 'action',
            sortable: false,
          },
        ],
        statusTranslations: [
          { text: this.$t('appointment.waitingCustomer'), value: 'waiting_customer_confirmation' },
          { text: this.$t('appointment.waitingSeller'), value: 'waiting_seller_confirmation' },
          { text: this.$t('appointment.confirmed'), value: 'confirmed' },
          { text: this.$t('appointment.cancelled'), value: 'cancelled' },
          { text: this.$t('appointment.done'), value: 'done' },
        ],
        appointments: [],
        totalAppointments: 0,
        loadingData: false,
        options: {
          itemsPerPage: 15,
        },
        sortBy: 'created_at',
        sortDesc: true,
        stores: null,
        store: null,
        mobileBreakpoint: 650,
      }
    },
    computed: {
      isMobile() {
        return this.$vuetify.breakpoint.width < this.mobileBreakpoint
      },
      filterAppointmentType() {
        switch (this.$route.params.type) {
          case 'pending':
            return ['waiting_customer_confirmation', 'waiting_seller_confirmation']
          case 'scheduled':
            return ['confirmed']
          case 'past':
            return ['done', 'cancelled']
          default:
            return ['waiting_customer_confirmation', 'waiting_seller_confirmation', 'confirmed', 'done', 'cancelled']
        }
      },
      ...mapState(['isAdmin', 'isShopManager', 'currentStore']),
      footerProps() {
        return {
          'items-per-page-options': [15, 30, 50],
          'items-per-page-text': this.$t('appointment.resultsPerPage'),
        }
      },
      headerProps() {
        return {
          sortByText: this.$t('order.sortByText'),
        }
      },
    },
    activated() {
      let previousPath = this.$store.state.previousPath.split('/')[1]
      // we reset current page number and appointments per page if the previous page wasn't the details of an appointment
      if (previousPath !== 'appointments') {
        this.options.itemsPerPage = 15
        this.options.page = 1
        this.options.sortBy = []
        this.options.sortDesc = []
        this.store = []
      }
      this.appointments = []
      this.list()
    },
    watch: {
      options: {
        handler() {
          this.list()
        },
      },
    },
    methods: {
      list() {
        this.loadingData = true
        let myInit = this.buildMyInit(this.store)
        this.$Amplify.API.get('appointments', '/appointments', myInit)
          .then((res) => {
            this.appointments = res.data
            this.totalAppointments = res.nbAppointments

            if (res.nbAppointments < (this.options.page - 1) * this.options.itemsPerPage + 1) {
              let pageNumber = Math.floor(res.nbAppointments / this.options.itemsPerPage)
              this.options.page = pageNumber === 0 ? 1 : pageNumber
            }
            this.loadingData = false
          })
          .catch(() => {
            this.loadingData = false
            EventBus.$emit('displaySnackbar', {
              display: true,
              text: 'error during appointments loading',
              color: 'error',
            })
          })
      },
      buildMyInit(location = null) {
        if (!this.isAdmin) {
          location = this.currentStore
        }
        let { page, itemsPerPage, sortDesc, sortBy } = this.options
        let myInit = {
          headers: {
            Authorization: 'Bearer ' + this.$auth.accessToken,
          },
          queryStringParameters: {
            sortBy: sortBy.length === 0 ? 'created_at' : sortBy,
            sortDesc: sortDesc.length === 0 ? true : sortDesc,
            page: page,
            itemsPerPage: itemsPerPage,
          },
        }
        if (this.$route.params.type) {
          myInit.queryStringParameters.status = this.filterAppointmentType
        }

        if (location) {
          myInit.queryStringParameters.location = location
        }
        return myInit
      },
      async reloadList() {
        await this.$auth.isAuthenticated()
        this.options.page = 1
        this.list()
      },
      formatDate(date) {
        return moment(date).format('DD/MM/YY HH:mm')
      },
      getStatusTranslation(statusValue) {
        let status = this.statusTranslations.find((status) => status.value === statusValue)
        if (status) {
          return status.text
        } else return statusValue
      },
      executeAction(appointmentId) {
        this.$router.push({
          name: 'appointmentsDetails',
          params: {
            id: appointmentId,
          },
        })
      },
    },
  }
</script>
